module.exports = __webpack_public_path__ + "media/images/favicon_v3-00fa0664fb6844444fdd248d47f3810b.ico";